module.exports = __webpack_public_path__ + "img/rivian.e1eaa2ab.png";